import { render, staticRenderFns } from "./ToDoCrud.vue?vue&type=template&id=0f9eaa52"
import script from "./ToDoCrud.vue?vue&type=script&lang=js"
export * from "./ToDoCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports